import { useQuery } from "@tanstack/react-query";
import {
  asyncGetItem,
  asyncGetList,
} from "@/setup/flexbiz-api-provider/coreFunction";
import { AppInfo } from "@/models/appInfo";
import { collection_name } from "@/types/projectConsts";
const DEFAULT_STALE_TIME = 60000; // 1min

export const fetchAppInfo = async (): Promise<AppInfo> => {
  const result = await asyncGetItem<AppInfo>({
    collection_name: collection_name.APP,
    access_token: process.env.public_token,
  });
  return result;
};
export const useFetchAppInfo = () =>
  useQuery({
    queryKey: ["appInfo"],
    queryFn: () => fetchAppInfo(),
    staleTime: DEFAULT_STALE_TIME,
  });

export const fetProductLines = async () => {
  asyncGetList({
    collection_name: "ecomproductlines",
    options: {
      page: 1,
      limit: 100,
      condition: {
        ma_nganh_hang: "NS",
        id_app: process.env.id_app,
      },
    },
  });
};
export const useFetchProductLine = () => {
  useQuery({
    queryKey: ["ecomproductlines"],
    queryFn: () => fetProductLines(),
    staleTime: DEFAULT_STALE_TIME,
  });
};

